document.addEventListener('DOMContentLoaded', function(){
    if(document.querySelectorAll('.main_menu_cu').length > 0){
        document.querySelectorAll('.main_menu_cu').forEach(function(elem){
            elem.addEventListener('click', function(e){
                e.preventDefault();
                let menu_item = elem.getAttribute('data-target');
                let target_parent = elem.closest('.mega-menu');
                target_parent.querySelector('.mega-menu__nav-content .mega-menu-child.active').classList.remove('active');
                target_parent.querySelector('.main_menu_cu a.active').classList.remove('active');
                elem.querySelector('a').classList.add('active');
                target_parent.querySelector('.mega-menu__nav-content .mega-menu-child[data-menu-item="'+menu_item+'"]').classList.add('active');
            });
        });
    }
});


var mega_menu_new_slider = new Swiper(".mega_menu_new_slider", {
  slidesPerView: 'auto',
  spaceBetween: 8,
  slidesOffsetAfter: 150,
  observer: true,
  observeSlideChildren: true,
  mousewheel: {
    forceToAxis: true,
    sensitivity: 1,
    releaseOnEdges: true
  }
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("li.main_menu_cu").forEach(function (menuItem) {
    menuItem.addEventListener("click", function (event) {
      event.preventDefault();

      const megaMenu = menuItem.closest(".mega-menu");
      if (!megaMenu) return;

      const childSubMenu = menuItem.querySelector("ul.sub_menu_cu");

      megaMenu.querySelectorAll("li.main_menu_cu").forEach(function (item) {
        item.classList.remove("active");
      });

      menuItem.classList.add("active");

      megaMenu.querySelectorAll("ul.sub_menu_cu").forEach(function (submenu) {
        submenu.style.display = "none";
      });

      if (childSubMenu) {
        childSubMenu.style.display = "flex";
      }
    });
  });
});


document.querySelectorAll('.mega-menu-child a').forEach(link => {
  link.addEventListener('click', e => {
    e.stopPropagation(); // allow navigation
  });
});


